/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../common/currency';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "common": {
            "nested": {
              "transfer_common": {
                "nested": {
                  "TransferNativeFlow": {
                    "fields": {
                      "linkBankAccount": {
                        "type": "squareup.bbfrontend.common.transfer_common.TransferNativeFlow.LinkBankAccount",
                        "id": 1
                      },
                      "linkDebitCard": {
                        "type": "squareup.bbfrontend.common.transfer_common.TransferNativeFlow.LinkDebitCard",
                        "id": 2
                      },
                      "paperCashDepositIn": {
                        "type": "squareup.bbfrontend.common.transfer_common.TransferNativeFlow.PaperCashDepositIn",
                        "id": 4
                      },
                      "checkDepositIn": {
                        "type": "squareup.bbfrontend.common.transfer_common.TransferNativeFlow.CheckDepositIn",
                        "id": 6
                      },
                      "transferSettings": {
                        "type": "squareup.bbfrontend.common.transfer_common.TransferNativeFlow.TransferSettings",
                        "id": 7
                      }
                    },
                    "nested": {
                      "Dependency": {
                        "nested": {
                          "TransferLimits": {
                            "fields": {
                              "minimum": {
                                "type": "squareup.common.Money",
                                "id": 1,
                                "rule": "optional"
                              },
                              "maximum": {
                                "type": "squareup.common.Money",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "LinkBankAccount": {
                        "fields": {
                          "instantTransferIntent": {
                            "type": "squareup.bbfrontend.common.transfer_common.TransferNativeFlow.LinkBankAccount.InstantTransferBankLinkingIntent",
                            "id": 1,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "InstantTransferBankLinkingIntent": {
                            "fields": {
                              "hasExistingBankAccount": {
                                "type": "bool",
                                "id": 1,
                                "rule": "optional"
                              },
                              "hasExistingDebitCard": {
                                "type": "bool",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "LinkDebitCard": {
                        "fields": {}
                      },
                      "PaperCashDepositIn": {
                        "fields": {}
                      },
                      "CheckDepositIn": {
                        "fields": {
                          "transferLimits": {
                            "type": "squareup.bbfrontend.common.transfer_common.TransferNativeFlow.Dependency.TransferLimits",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "TransferSettings": {
                        "fields": {}
                      },
                      "flow": {
                        "oneof": ["linkBankAccount", "linkDebitCard", "paperCashDepositIn", "checkDepositIn", "transferSettings"]
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.transfer_common?.nested?.TransferNativeFlow && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.transfer_common?.nested?.TransferNativeFlow?.nested?.Dependency?.nested?.TransferLimits && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.transfer_common?.nested?.TransferNativeFlow?.nested?.LinkBankAccount && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.transfer_common?.nested?.TransferNativeFlow?.nested?.LinkBankAccount?.nested?.InstantTransferBankLinkingIntent && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.transfer_common?.nested?.TransferNativeFlow?.nested?.LinkDebitCard && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.transfer_common?.nested?.TransferNativeFlow?.nested?.PaperCashDepositIn && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.transfer_common?.nested?.TransferNativeFlow?.nested?.CheckDepositIn && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.transfer_common?.nested?.TransferNativeFlow?.nested?.TransferSettings) {
  $root.addJSON(jsonData);
}

/**
 * Flows that transfer clients can initiate that require injected dependencies
 * Please note that a mechanism must exist for the client to inform bbfrontend of the flows that it can support!
 * For example, FlexibleTransfers uses a list of `TransferClientCapableFlow` in the request.
 *
 * SOURCE TransferNativeFlow @ squareup/bbfrontend/common/transfer_common/transfer_native_flow.proto at 16:1
 */
export const TransferNativeFlow = $root.lookupType('squareup.bbfrontend.common.transfer_common.TransferNativeFlow');
fixType(TransferNativeFlow);
Builder.createAndAttachToType(TransferNativeFlow);
/**
 * SOURCE Dependency @ squareup/bbfrontend/common/transfer_common/transfer_native_flow.proto at 17:3
 */
TransferNativeFlow.Dependency = {};
/**
 * The limits a transfer can have
 *
 * SOURCE TransferLimits @ squareup/bbfrontend/common/transfer_common/transfer_native_flow.proto at 26:5
 */
TransferNativeFlow.Dependency.TransferLimits = $root.lookupType('squareup.bbfrontend.common.transfer_common.TransferNativeFlow.Dependency.TransferLimits');
fixType(TransferNativeFlow.Dependency.TransferLimits, {
  minimum: {
    required: true
  },
  maximum: {
    required: true
  }
});
Builder.createAndAttachToType(TransferNativeFlow.Dependency.TransferLimits);
/**
 * Direct the client to initiate the bank linking flow.
 *
 * SOURCE LinkBankAccount @ squareup/bbfrontend/common/transfer_common/transfer_native_flow.proto at 33:3
 */
TransferNativeFlow.LinkBankAccount = $root.lookupType('squareup.bbfrontend.common.transfer_common.TransferNativeFlow.LinkBankAccount');
fixType(TransferNativeFlow.LinkBankAccount);
Builder.createAndAttachToType(TransferNativeFlow.LinkBankAccount);
/**
 * SOURCE InstantTransferBankLinkingIntent @ squareup/bbfrontend/common/transfer_common/transfer_native_flow.proto at 34:5
 */
TransferNativeFlow.LinkBankAccount.InstantTransferBankLinkingIntent = $root.lookupType('squareup.bbfrontend.common.transfer_common.TransferNativeFlow.LinkBankAccount.InstantTransferBankLinkingIntent');
fixType(TransferNativeFlow.LinkBankAccount.InstantTransferBankLinkingIntent, {
  hasExistingBankAccount: {
    required: true
  },
  hasExistingDebitCard: {
    required: true
  }
});
Builder.createAndAttachToType(TransferNativeFlow.LinkBankAccount.InstantTransferBankLinkingIntent);
/**
 * Direct the client to initiate the debit card linking flow to link an external debit card.
 *
 * SOURCE LinkDebitCard @ squareup/bbfrontend/common/transfer_common/transfer_native_flow.proto at 43:3
 */
TransferNativeFlow.LinkDebitCard = $root.lookupType('squareup.bbfrontend.common.transfer_common.TransferNativeFlow.LinkDebitCard');
fixType(TransferNativeFlow.LinkDebitCard);
Builder.createAndAttachToType(TransferNativeFlow.LinkDebitCard);
/**
 * Direct the client to initiate cash deposit flow
 *
 * SOURCE PaperCashDepositIn @ squareup/bbfrontend/common/transfer_common/transfer_native_flow.proto at 46:3
 */
TransferNativeFlow.PaperCashDepositIn = $root.lookupType('squareup.bbfrontend.common.transfer_common.TransferNativeFlow.PaperCashDepositIn');
fixType(TransferNativeFlow.PaperCashDepositIn);
Builder.createAndAttachToType(TransferNativeFlow.PaperCashDepositIn);
/**
 * Direct the client to initiate a check deposit.
 *
 * SOURCE CheckDepositIn @ squareup/bbfrontend/common/transfer_common/transfer_native_flow.proto at 49:3
 */
TransferNativeFlow.CheckDepositIn = $root.lookupType('squareup.bbfrontend.common.transfer_common.TransferNativeFlow.CheckDepositIn');
fixType(TransferNativeFlow.CheckDepositIn, {
  transferLimits: {
    required: true
  }
});
Builder.createAndAttachToType(TransferNativeFlow.CheckDepositIn);
/**
 * Direct the client to initiate navigation to transfer settings.
 *
 * SOURCE TransferSettings @ squareup/bbfrontend/common/transfer_common/transfer_native_flow.proto at 54:3
 */
TransferNativeFlow.TransferSettings = $root.lookupType('squareup.bbfrontend.common.transfer_common.TransferNativeFlow.TransferSettings');
fixType(TransferNativeFlow.TransferSettings);
Builder.createAndAttachToType(TransferNativeFlow.TransferSettings);